import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../filter/FilterButton'

const FilterButtonAudit = () => {
  const open = useSelector(state => state?.filter?.audit?.open || false)

  return (
    <>
      <FilterButton 
        module='audit' 
        keysFilter={['userId', 'roleId', 'module', 'action']} 
      />
      { open &&
        <FilterDialog />
      }
    </>
  )
}
export default FilterButtonAudit